import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'
import { REASSIGNMENT_TREATING_PHYSICIAN } from './const'

export const initialState = {
    reassignment: {
        reassignTo: REASSIGNMENT_TREATING_PHYSICIAN,
        currentTreatingPhysicianId: null,
        newTreatingPhysicianId: null,
        partnerPhysicianId: null,
        confirmationLegalRequirementsMet: false,
    },
    fetching: false,
    error: null,
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.CHANGE_REASSIGNMENT]: (state, action) => {
        const { name, value } = action.payload

        return {
            ...state,
            reassignment: {
                ...state.reassignment,
                [name]: value,
            },
        }
    },
    [type.REASSIGN_TREATING_PHYSICIAN_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.REASSIGN_TREATING_PHYSICIAN_SUCCESS]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.REASSIGN_TREATING_PHYSICIAN_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.REASSIGN_TO_PARTNER_PHYSICIAN_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/treatment/state/reassign/reducer.js